import { Component, Input, ViewEncapsulation } from '@angular/core';
import {ManagementFacadeService} from '@emm/management/services/management-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-management-attributes-header',
    styleUrls: ['./management-attributes-header.component.scss'],
    templateUrl: './management-attributes-header.component.html'
})
export class ManagementAttributesHeaderComponent {

    @Input() disabledSource: string;
    @Input() name: string;
    @Input() tag: string;
    @Input() type: string;
    @Input() description: string;

    selectedScreen$ = this.managementFacade.selectedScreen$;

    constructor(private managementFacade: ManagementFacadeService) {}

}
